import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        d: "M15.805.196a.667.667 0 0 0-.943 0L8 7.058 1.138.196a.667.667 0 0 0-.943 0 .667.667 0 0 0 0 .942L7.057 8 .195 14.862a.667.667 0 0 0 0 .943.667.667 0 0 0 .943 0L8 8.943l6.862 6.862a.667.667 0 0 0 .943-.943L8.943 8l6.862-6.862a.667.667 0 0 0 0-.942",
        fill: "currentColor"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("rect", {
          width: "16",
          height: "16",
          fill: "white"
        })
      ])
    ], -1)
  ])))
}
export default { render: render }